import { useTextTranslation } from "../../utils/useTextTranslation";
import { catalogLabel } from "../../utils/catalogLabel";
import { isContinueWatching } from "../../utils/watchProgress";
import { toTrackId } from "../../analytics/trackIds";
import { ErrorState, LoadingState } from "../status/StatusView";
import { loadRequest } from "../../utils/loadRequest";
import useCarouselScroll from "../../utils/useCarouselScroll";
import CinemaIcon from "../cinema/CinemaIcon";
import { getCinemaCopy } from "../../statics/cinemaCopy";
import React, { useContext, useEffect, useRef, useState } from "react";
import VodItem from "../vodItem";
import { useHistory, useParams } from "react-router-dom";
import {
  getVodsByLabel,
  toggleFavById,
  getFavList,
  deleteBookmarkById
} from "../../api/vod/vod";
import {
  getRelatedVods,
  getUserMaybeLikeData
} from "../../api/common/commonApi";
import { sendCustomFavoriteReport } from "../../utils/reporting/customReporting";
import TrashIcon from "../../assets/icons/svg/TrashIcon";
import AngleRightIcon from "../../assets/icons/svg/AngleRightIcon";
import localizationStrings from "../../statics/localization";
import { SessionContext } from "../../context/SessionContext";
import { getShelfPresentation } from "./shelfPresentation";
import "./RankedShelf.scss";

const Carousel = ({
  column,
  slidesToShow,
  slidesToScroll,
  vod,
  label,
  margin,
  dontUseGrid,
  padding,
  onHoverItem
}) => {
  const translateText = useTextTranslation();
  const copy = getCinemaCopy();
  const continueWatching = isContinueWatching(label);
  const railTrackId = (...parts) => toTrackId("rail", label?.id, ...parts);
  const presentation = getShelfPresentation(label);
  const isRanked = presentation === "ranked";
  const [viewport, setViewport] = useState(window.innerWidth);
  useEffect(() => {
    const resize = () => setViewport(window.innerWidth);
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);
  const [vods, setVods] = useState([]);
  const [loadError, setLoadError] = useState(null);
  const [loading, setLoading] = useState(!!label);
  const requestVersion = useRef(0);
  const requestPending = useRef(false);
  const mounted = useRef(false);
  const failedReplace = useRef(false);
  const [isVertical, setIsVertical] = useState(false);
  const usePortrait = isRanked || isVertical;
  const [showOptions, setShowOptions] = useState(false);
  const [favVodsLength, setFavVodsLength] = useState(0);
  const optionRef = useRef(null);
  const delCount = useRef(0);
  const timeoutRef = useRef(null);
  const pageNo = useRef(0);
  const vodRef = useRef([]);
  const totalCountRef = useRef(0);
  const {
    userFrameConfig,
    isChangeFavList,
    isChangeBookmarked,
    setIsChangeBookmarked
  } = useContext(SessionContext);
  const history = useHistory();
  const { menuId, categoryId } = useParams();

  let pageItemCount = 16; // request for other pages vod count

  const responsiveCount = isRanked
    ? viewport < 600
      ? 1.6
      : viewport < 1000
      ? 2.7
      : viewport < 1500
      ? 3.7
      : 5.2
    : viewport < 600
    ? isVertical
      ? 2.3
      : 1.35
    : viewport < 1000
    ? isVertical
      ? 3.5
      : 2.3
    : viewport < 1500
    ? isVertical
      ? 5.5
      : 3.3
    : isVertical
    ? 6.5
    : 4.3;
  slidesToShow = slidesToShow || responsiveCount;
  slidesToScroll = slidesToScroll || Math.max(1, Math.floor(slidesToShow));

  const getVodList = async (removeOldContents = false) => {
    if (!mounted.current || requestPending.current) return;
    const version = requestVersion.current;
    requestPending.current = true;
    failedReplace.current = removeOldContents;
    setLoadError(null);
    setLoading(true);
    try {
      // Handle labels that already provide their content items directly.
      if (label?.type === "CATCHUP" || label?.type === "RECOMMENDATION_USER") {
        if (removeOldContents) vodRef.current = [];
        vodRef.current = label.catchups || label.contents || [];
        totalCountRef.current = vodRef.current.length;
        setVods(vodRef.current);
        setIsVertical(label?.vertical ?? label?.type === "RECOMMENDATION_USER");
        return;
      }

      const { data } = await loadRequest((options) =>
        getVodsByLabel(label.id, pageNo.current, pageItemCount, options)
      );

      if (!mounted.current || version !== requestVersion.current) return;
      if (!Array.isArray(data?.contents))
        throw new Error("Invalid shelf response");
      pageNo.current++;

      if (data.contents) {
        if (removeOldContents) vodRef.current = [];
        vodRef.current = vodRef.current.concat(data?.contents);
        totalCountRef.current = data?.totalContents;
        setVods(vodRef.current);

        setIsVertical(data?.vertical);
        if (pageNo.current === 1 && label?.id === 78) {
          timeoutRef.current && clearTimeout(timeoutRef.current);
          timeoutRef.current = setTimeout(() => {
            reset();
          }, 200);
        }
      }
    } catch (error) {
      if (mounted.current && version === requestVersion.current)
        setLoadError(error);
    } finally {
      if (mounted.current && version === requestVersion.current) {
        requestPending.current = false;
        setLoading(false);
      }
    }
  };
  const getUserFavList = async () => {
    setVods([]);
    const data = await getFavList("1,4,19", userFrameConfig.Search_Column);
    if (data.data.returncode === "0") {
      setVods(data.data.data);
      setFavVodsLength(data.data.data.length);

      timeoutRef.current && clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        reset();
      }, 200);
    } else {
      setFavVodsLength(0);
    }
  };

  const removeAllContentsFromContinueWatching = async () => {
    if (Array.isArray(vods) && vods.length > 0) {
      await Promise.all(
        vods.map((item) => {
          deleteBookmarkById(item.id);
        })
      );
      setVods([]);
    }
  };

  const removeContentFromContinueWatching = async (itemId) => {
    const data = await deleteBookmarkById(itemId);
    if (data.status === 200) {
      console.log("data", data);

      setVods((prevVods) => prevVods.filter((vod) => vod.id !== itemId));
    }
  };

  const removeContentFromFavorite = async (item, isRemoveAll) => {
    let favType;

    // if (item?.favoritetype == "19") {
    //   favType = 19;
    // } else {
    //   if (item.programtype == 1 || item.programtype == 10) {
    //     favType = 1;
    //   } else if (parseInt(item.price)) {
    //     favType = 2;
    //   } else {
    //     favType = 4;
    //   }
    // }
    console.log("item", item.id);
    const data = await toggleFavById(item.id);

    if (data.status === 200) {
      if (isRemoveAll) {
        delCount.current++;
        if (delCount.current == vods.length) {
          setVods([]);
          setFavVodsLength(0);
        }
      } else {
        // vodRef.current = [];
        // setVods([]);
        pageNo.current = 0;
        getVodList(true); // first remove old contents
      }
    }
  };
  const { trackRef, canPrevious, canNext, move, reset } = useCarouselScroll({
    itemCount: isRanked ? Math.min(vods.length, 10) : vods.length,
    resetKey: label?.id,
    onInteraction: () => onHoverItem?.(false),
    onNearEnd: () => {
      if (
        !loadError &&
        totalCountRef.current > vodRef.current.length &&
        (!isRanked || vodRef.current.length < 10)
      )
        getVodList();
    }
  });

  useEffect(() => {
    mounted.current = true;
    requestVersion.current++;
    requestPending.current = false;
    pageNo.current = 0;
    vodRef.current = [];
    setVods([]);
    if (label) getVodList();
    return () => {
      mounted.current = false;
      requestVersion.current++;
      clearTimeout(timeoutRef.current);
    };
  }, [label]);

  useEffect(() => {
    if (!!vod?.relatedContents) {
      //slidesToShow = 4;
    }
  }, []);

  useEffect(() => {
    if (!!vod?.relatedContents) {
      setVods(vod?.relatedContents);
      setIsVertical(true);
      //slidesToShow = 4;
    }
  }, [vod?.relatedContents]);

  useEffect(() => {
    if (isChangeFavList && label?.id === 78) {
      //vodRef.current = [];
      //setVods([]);
      pageNo.current = 0;
      getVodList(true); //first remove old contents
    }
  }, [isChangeFavList]);

  useEffect(() => {
    if (isChangeBookmarked && continueWatching) {
      pageNo.current = 0;
      getVodList(true);
      setIsChangeBookmarked(false);
    }
  }, [isChangeBookmarked]);

  const visibleVods = isRanked ? vods.slice(0, 10) : vods;
  const items = visibleVods.map((vod, index) => {
    return (
      <VodItem
        key={vod.id}
        item={vod}
        showProgress={continueWatching}
        isFavList={label?.id === 78}
        useContentType={false}
        isVertical={usePortrait}
        rank={isRanked ? index + 1 : undefined}
        isCatchup={label?.type === "CATCHUP"}
        label={label}
        removeFromFav={(item) => removeContentFromFavorite(item, false)}
        removeFromKeepWatch={(item) =>
          removeContentFromContinueWatching(item.id)
        }
        index={index}
        onHoverItem={onHoverItem}
        slidesToScroll={slidesToScroll}
      />
    );
  });

  const canOpenShelf = !dontUseGrid && !!label?.id;

  const openShelf = () => {
    if (!canOpenShelf) return;
    if (label?.type === "CATCHUP") {
      const actualLabelId = String(label.id).replace("catchups_", "");
      history.push(`/dashboard/catchup/${menuId}/${actualLabelId}`);
    } else {
      history.push(
        `/dashboard/genre/${label?.id}/${encodeURIComponent(catalogLabel(label?.name, label?.type) || "")}`
      );
    }
  };

  const errorPanel = loadError && (
    <ErrorState
      size="compact"
      error={loadError}
      onRetry={() => getVodList(failedReplace.current)}
    />
  );
  // Reserve space while the first shelf loads so lower shelves do not all
  // enter the viewport and start their requests in the same frame.
  if (loading && !vods.length && !loadError)
    return (
      <section className="cinema-deferred-shelf" aria-label={translateText(catalogLabel(label?.name, label?.type))}>
        <LoadingState size="compact" />
      </section>
    );
  if (loadError && !vods.length)
    return (
      <section
        className="content-carousel cinema-shelf"
        aria-label={translateText(catalogLabel(label?.name, label?.type))}
      >
        <h3>{translateText(catalogLabel(label?.name, label?.type))}</h3>
        {errorPanel}
      </section>
    );

  return (
    <div
      className={`content-carousel cinema-shelf ${
        usePortrait ? "cinema-shelf-portrait" : "cinema-shelf-landscape"
      }${isRanked ? " cinema-shelf-ranked" : ""}`}
      style={{
        display: !vods.length ? "none" : "",
        padding: padding
      }}
      key={label?.id}
    >
      <div className="cinema-shelf-heading">
        <label
          data-track-id={railTrackId("title")}
          className="label-title"
          style={{
            marginLeft: margin
          }}
          role={dontUseGrid || !label?.id ? undefined : "link"}
          tabIndex={dontUseGrid || !label?.id ? undefined : 0}
          onKeyDown={(event) => {
            if (event.key === "Enter") openShelf();
          }}
          onClick={openShelf}
          //label.columncode,label.columntype
        >
          {!!vod?.relatedContents ? (
            <span>{column?.columnname}</span>
          ) : (
            <span>
              {translateText(label?.id === "recommendedforuser" ? copy.forYou : catalogLabel(label?.name, label?.type))}
            </span>
          )}
          {!dontUseGrid ? (
            <CinemaIcon className="see-all-icon" name="next" />
          ) : null}

          {label?.id == "78" || continueWatching ? (
            <div
              ref={optionRef}
              data-track-id={railTrackId("options")}
              className="dot-options"
              onClick={(e) => {
                e.stopPropagation();
                setShowOptions(!showOptions);
              }}
            >
              <div className="dots-wrapper" style={{ right: "0px" }}>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>

                <div className={`options-box ${showOptions ? "show" : ""}`}>
                  <div className="tri-angle"></div>
                  <div className="options">
                    <div
                      data-track-id={railTrackId("remove_all")}
                      className="option"
                      onClick={() => {
                        if (continueWatching) {
                          removeAllContentsFromContinueWatching();
                        } else if (label?.id === 78)
                          vods.forEach((item) => {
                            removeContentFromFavorite(item, true);
                          });
                      }}
                    >
                      <TrashIcon />
                      <span>{localizationStrings.removeList}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </label>
        <div className="cinema-shelf-controls">
          <button
            type="button"
            className="cinema-icon-button"
            data-track-id={railTrackId("prev")}
            aria-label={`${copy.previous}: ${
              catalogLabel(label?.name, label?.type) || column?.columnname || ""
            }`}
            disabled={!canPrevious}
            onClick={() => move(-1)}
          >
            <CinemaIcon name="previous" />
          </button>
          <button
            type="button"
            className="cinema-icon-button"
            data-track-id={railTrackId("next")}
            aria-label={`${copy.next}: ${
              catalogLabel(label?.name, label?.type) || column?.columnname || ""
            }`}
            disabled={!canNext}
            onClick={() => move(1)}
          >
            <CinemaIcon name="next" />
          </button>
        </div>
      </div>
      {errorPanel}
      <div
        className="cinema-scroll-track"
        ref={trackRef}
        style={{ "--carousel-item-width": `${100 / slidesToShow}%` }}
      >
        {items}
      </div>
    </div>
  );
};

export default Carousel;
